import { Entry } from '../Entry'

export function Entry20220622() {
  return (
    <Entry title="22/06/2022 - v3.0.12">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12636/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
